import { red } from "@mui/material/colors";
import { components } from "./components";

interface ThemeOptions {
  typography: {
    fontSize: number;
    body1: {
      fontSize: string;
    };
  };
  status: {
    danger: string;
  };
  components: Record<string, unknown>;
}

const themeOptions: ThemeOptions = {
  typography: {
    fontSize: 14,
    body1: { fontSize: "14px" },
  },
  status: { danger: red[500] },
  components: { ...components },
};

export default themeOptions;